'use client'

import { ReactNode, useRef } from 'react'

// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useWindowEvent } from '@marketplace-web/shared/browser'

type Props = {
  onOutsideClick: (event: MouseEvent) => void
  isDisabled?: boolean
  children: ReactNode
  className?: string
}

const OutsideClick = ({ onOutsideClick, isDisabled = false, children, className }: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useWindowEvent('mousedown', (event: MouseEvent) => {
    const { current: node } = wrapperRef

    if (!node || isDisabled) return
    if (event.target instanceof Node && node.contains(event.target)) return

    onOutsideClick(event)
  })

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  )
}

export default OutsideClick
